export default {"src":"/_next/static/media/rocket-ship.bb2e3346.svg","height":448,"width":500};